import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Logo } from './Logo';
import { ThemeToggle } from './ThemeToggle';
import { AuthStatus } from './AuthStatus';

export function TopBar(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  const handleBack = () => {
    navigate('/');
  };

  return (
    <header className="bg-white dark:bg-gray-950 shadow-sm border-b border-gray-200 dark:border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-between gap-3 py-4">
          <div className="flex min-w-0 items-center gap-4">
            {!isHome && (
              <button
                onClick={handleBack}
                className="btn-secondary text-sm"
                aria-label="Go back to home"
              >
                <span aria-hidden="true">&larr; </span>
                <span className="sm:hidden">Home</span>
                <span className="hidden sm:inline">Back to Home</span>
              </button>
            )}
            <Link to="/" className="flex items-center">
              <Logo size="md" className="justify-start" logoWidth="w-5" />
            </Link>
          </div>
          <div className="ml-auto flex items-center gap-3">
            <div data-testid="theme-toggle">
              <ThemeToggle />
            </div>
            {!isHome && (
              <AuthStatus
                compact={false}
                signInAlign="end"
              />
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
